import { msg } from '@lingui/macro';

export const StyleRoutes = {
  path: 'style',
  async lazy() {
    const { Parent } = await import('../pages/style');
    return { Component: Parent };
  },
  handle: { name: 'Styles list', category: 'Styles', title: msg`Styles` },
  children: [
    {
      index: true,
      async lazy() {
        const { Index } = await import('../pages/style');
        return { Component: Index };
      },
    },
    {
      path: '*',
      async lazy() {
        const { Parent } = await import('../pages/style');
        return { Component: Parent };
      },
      handle: { name: 'Style Details', category: 'Style' },
    },
  ],
};
